module.exports = __webpack_public_path__ + "img/image.956547c9.svg";